import React, { createContext, useReducer } from 'react'
import employeeReducer from './EmployeeReducer'
const initialState = { employees: false, loading: true, totalPages: 0 }

export const EmployeeContext = createContext(initialState)

export const EmployeeContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(employeeReducer, initialState)

  function getAllEmployees(employees, totalPage) {
    dispatch({
      type: 'GET_ALL_EMPLOYEES',
      payload: employees,
      totalPages: totalPage,
    })
  }

  function addEmployee(employee) {
    dispatch({
      type: 'ADD_EMPLOYEE',
      payload: employee,
    })
  }

  function editEmployee(employee) {
    dispatch({
      type: 'EDIT_EMPLOYEE',
      payload: employee,
    })
  }

  function removeEmployee(id) {
    //console.log('ID : ', id)
    dispatch({
      type: 'REMOVE_EMPLOYEE',
      payload: id,
    })
  }

  return (
    <EmployeeContext.Provider
      value={{
        loading: state.loading,
        totalPages: state.totalPages,
        getNewEmployees: getAllEmployees,
        employees: state.employees,
        addNewEmployee: addEmployee,
        editNewEmployee: editEmployee,
        deleteNewEmployee: removeEmployee,
      }}
    >
      {children}
    </EmployeeContext.Provider>
  )
}
